module.exports = __webpack_public_path__ + "img/link-4.e29537a3.png";